import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {ProductoPlazoInversionCanal} from '../_models/producto-plazo-inversion-canal';

@Injectable({
  providedIn: 'root'
})
export class ProductoPlazoInversionCanalService {
  private rutServicio: string = AppSettings.rutServiciosAPL + "/api/productosPlazosInversionCanal";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService,
  ) {}

  getAll(): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(this.rutServicio);
  }

  getEnabled(): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/enabled}`);
  }

  getById(id: string): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/${id}`);
  }

  getByIdProducto(id: string): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/producto/${id}`);
  }

  getEnabledByIdProducto(id: string): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/producto/${id}/enabled`);
  }

  getByIdProductoPlazoInversion(id: string): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/productoPlazoInversion/${id}`);
  }

  getEnabledByIdProductoPlazoInversion(id: string): Observable<ProductoPlazoInversionCanal[]> {
    return this.httpClient.get<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/productoPlazoInversion/${id}/enabled`);
  }

  create(registro: ProductoPlazoInversionCanal): Observable<ProductoPlazoInversionCanal> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post<ProductoPlazoInversionCanal>(this.rutServicio, registro);
  }

  update(registro: ProductoPlazoInversionCanal): Observable<ProductoPlazoInversionCanal> {
    registro.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put<ProductoPlazoInversionCanal>(this.rutServicio, registro);
  }

  bulk(registros: ProductoPlazoInversionCanal[]): Observable<ProductoPlazoInversionCanal[]> {
    registros.forEach((e: ProductoPlazoInversionCanal) => e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado());
    return this.httpClient.post<ProductoPlazoInversionCanal[]>(`${this.rutServicio}/bulk`, registros);
  }
}
